import { render, staticRenderFns } from "./AppDescription.vue?vue&type=template&id=865ce1b8"
import script from "./AppDescription.vue?vue&type=script&lang=js"
export * from "./AppDescription.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports